import { render, staticRenderFns } from "./users.vue?vue&type=template&id=2a72c20c&scoped=true&"
import script from "./users.vue?vue&type=script&lang=js&"
export * from "./users.vue?vue&type=script&lang=js&"
import style0 from "./users.vue?vue&type=style&index=0&id=2a72c20c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a72c20c",
  null
  
)

export default component.exports